import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getFormulaire } from "../services/formulaireApi";
import { Col, Container, Row, Card, CardBody, CardTitle, Spinner, Alert, Button, Form } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import "../utils/style.css";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";  
import ReactQuill from "react-quill";

const DetailTypeInspection = () => {
  const history = useContext(HistoryContext);
  document.title = `Formulaires | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const { type } = useParams();
  console.log("Type récupéré de l'URL :", type);

  const { data: formulaires, isLoading, isError, error } = useQuery("formulaires", getFormulaire);
  const [filteredFormulaires, setFilteredFormulaires] = useState([]);
  const [category, setCategory] = useState(null);

  // Déclaration des états pour stocker les valeurs des champs du formulaire
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [questions, setQuestions] = useState("");

  useEffect(() => {
    if (formulaires && type) {
      const filtered = formulaires.filter((formulaire) => formulaire.type === type);
      setFilteredFormulaires(filtered);
      if (filtered.length > 0) {
        setCategory(filtered[0].category);
        // Pré-remplir les champs avec les valeurs du premier formulaire filtré (ou tout autre formulaire que tu choisis)
        setName(filtered[0].name);
        setDescription(filtered[0].description);
        setQuestions(filtered[0].questions); // ou l'index d'un formulaire spécifique
      }
    }
  }, [formulaires, type]);

  if (isLoading) {
    return <Spinner color="primary" />;
  }

  if (isError) {
    return <Alert color="danger">{error?.message || "Une erreur est survenue."}</Alert>;
  }
 
  // Gestionnaire d'événements pour les inputs
  const handleNameChange = (e) => setName(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleQuestionsChange = (content) => setQuestions(content);

  // Fonction pour sélectionner un formulaire spécifique
  const handleFormSelection = (formulaire) => {
    setName(formulaire.name);
    setDescription(formulaire.description);
    setQuestions(formulaire.questions);
  };
  // État pour gérer l'ouverture ou la fermeture de chaque card
  const [openedCards, setOpenedCards] = useState({});
   // Lors du premier rendu, rendre le premier formulaire ouvert
   useEffect(() => {
    if (filteredFormulaires.length > 0) {
      setOpenedCards((prevState) => ({
        ...prevState,
        [filteredFormulaires[0].id]: true, // Ouvre le premier card par défaut
      }));
    }
  }, [filteredFormulaires]);
  // Fonction pour toggler l'état d'une card spécifique
  const toggleCard = (id) => {
    setOpenedCards((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Inverse l'état de la card avec cet id
    }));
  };
   const navigate = useNavigate();
    // Ajouté : fonction pour rediriger vers le détail du formulaire basé sur le type
    const handleDetail = (type) => {
        navigate(`/modifier/${type}`); // Redirige vers la page avec l'ID du formulaire
      };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            className="breadCrumb"
            page={`Page détail formulaire d'inspection > ${category ? ` ${category}` : ''} > ${type}`}
            history={history}
          />
          <Row className="justify-content-center">
            <Card className="card">
              <Row className="justify-content-center">
                <Col md={4} className="typse" style={{ marginTop: '10px' }}>{type}</Col>
                <Col md={8} style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                
                  <Button className="bordered-btn-lightDetail" color="light" onClick={() => handleDetail(type)}>
                    <EditOutlined style={{ color: '#252525' }} />
                    <span style={{ marginLeft: '10px' }}>Editer </span>
                  </Button>
                  <Button className="bordered-btn-lightDetail" color="light">
                    <DeleteOutlined style={{ color: '#F22A2A' }} />
                    <span style={{ marginLeft: '10px' }}>Supprimer</span>
                  </Button>
                </Col>
              </Row>
              <Row className="justify-content-center" style={{ marginLeft: '30px', marginRight: '30px'}}>
              {filteredFormulaires.map((formulaire, index) => (
                   <Card style={{ border: '1px solid #D9D9D9', marginLeft: '30px', marginRight: '30px' }}>
                   <CardBody>
                       
                     <Row className="justify-content-center">
                       <Col md={4} className="titre">{formulaire.name}</Col>
                       <Col className="ml-auto justify-content-end" style={{
                         display: "flex",
                         alignItems: "center",
                         marginRight: '8px',
                         width: "100%",
                         marginBottom: "16px"
                       }}>
                         <span
                        className="pointDetail"
                        onClick={() => toggleCard(formulaire.id)} // Toggle l'état de ce card spécifique
                      >
                        {openedCards[formulaire.id] ? (
                          <FaChevronUp size={10} color="dark" />
                        ) : (
                          <FaChevronDown size={10} color="dark" />
                        )}
                      </span>
                       </Col>
                     </Row>
                     {openedCards[formulaire.id] && (
                         <Form>
                         <Row className="justify-content-center">
                           <Col md={12}>
                             <div className="mb-3">
                               <label htmlFor="name" className="form-label labels" >
                                 Titre <span className="text-danger">*</span>
                               </label>
                               <input
                                 type="text"
                                 id="name"
                                 name="name"
                                 placeholder="Veuillez renseigner le nom du formulaire à créer"
                                 className="form-control values"
                                 value={formulaire.name} 
                                 onChange={handleNameChange}
                                 required
                               />
                             </div>
                           </Col>
                         </Row>
                         <Row className="justify-content-center">
                           <Col md={12}>
                             <div className="mb-3">
                               <label htmlFor="description" className="form-label labels" >
                                 Instruction <span className="text-danger">*</span>
                               </label>
                               <textarea
                                 id="description"
                                 name="description"
                                 className="form-control values"
                                 value={formulaire.description}
                                 onChange={handleDescriptionChange}
                                 rows="4"
                                 style={{ border: '1px solid #D9D9D9' }}
                               />
                             </div>
                           </Col>
                         </Row>
                         <Row className="justify-content-center">
                           <Col md={12}>
                             <label className="form-label labels">
                               Questions <span className="text-danger">*</span>
                             </label>
                             <ReactQuill
                             className="values"
                             value={formulaire.question} 
                               onChange={handleQuestionsChange}
                               modules={{
                                 toolbar: [
                                   ["bold", "italic", "underline"],
                                   ["blockquote"],
                                   [{ list: "ordered" }, { list: "bullet" }],
                                   ["link"],
                                   [{ align: [] }],
                                 ],
                               }}
                               theme="snow"
                               placeholder="Écrivez votre question ici..."
                             />
                           </Col>
                         </Row>
                       </Form>
                     )}
                    
                   </CardBody>
                 </Card>
              ))}
           
              </Row>
             
            </Card>
          </Row>

       
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailTypeInspection;
